import ArticleTemplate from '@/pages/article/components/ArticleTemplate';

export default function ArticleFinds() {
  return <ArticleTemplate slug="best-sugargoo-finds" />;
}